<div class="container-fluid row col-12 no-gutters">
  <div class="col-xl-9 col-md-9 col-sm-12 no-gutters">
    <div class="col-xl-9 col-md-9 col-sm-12 m-auto no-gutters">
      <h6 class="col-12 mb-3 text-normal">
        <strong>Application Description</strong>
      </h6>
      <div class="col-12 text-normal mb-3">GE Vernova Renewable’s Product Lifecycle Management application.
      </div>
      <h6 class="col-12 text-normal">
        <strong>Registration Question</strong>
      </h6>
      <div class="row col-12 mt-3 no-gutters text-normal">
        <p>To access Corella, please reach out to your GE Supplier Representative or GE Sponsor for a request to be
          raised. 
        </p> <br >

        <p>Once a request is raised, you will receive an email to confirm your request and proceed for approval.</p>
        <p>
          If you already have access, click <a href="https://corella.ren.apps.ge.com/innovator" class="text-highlight">
            here
          </a>
          to enter the application or click “Go To Application” on this page.
        </p>
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-12 col-md-3 col-xl-3 no-gutters">
    <div class="row no-gutters col-12 align-items-center justify-content-center d-none d-sm-block">
      <button class="btn btn-primary btn-vernova button col-12" style="font-size: 18px;" (click)="goToApplication()">
        <span>
          Go To Application
          <i class='fa fa-sign-out pl-2' style="color: #fff;"></i>
        </span>
      </button>
    </div>
    <hr>
    <div class="col-12">
      <h6>
        <strong class="mt-3 text-lable">
          Support
        </strong>
      </h6>
      <div class="col-12 mt-3 p-0 text-normal d-block d-sm-none">
        <button class="btn btn-primary btn-vernova button col-12" style="font-size: 18px;" (click)="goToApplication()">
          <span>
            Go To Application
            <i class='fa fa-sign-out pl-2' style="color: #fff;"></i>
          </span>
        </button>
        <hr>
      </div>
      <div class="col-12 mt-3 text-normal p-0">
        GE Renewable Energy Supplier Support (<a href="mailto:GERenEnergy.SupplierSupport@ge.com"
          style="word-wrap: break-word;" class="text-highlight">~GE Vernova Supplier Support</a>)
      </div>
    </div>
    <hr>
  </div>
</div>